import { render } from "./Index.vue?vue&type=template&id=2adc1d38&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2adc1d38&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=2adc1d38&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src192932826/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adc1d38"]])

export default __exports__